import { environment } from '../../../../environments/environment';
import { AfterViewInit, Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NavigationService } from '../../../services/navigation-service';
import { CuentasService, CUENTA_TYPE_PROVEEDOR, CUENTA_TYPE_PROSPECTO, CUENTA_TYPE_CLIENTE } from '../../../services/cuentas-service';
import { DialogsService } from '../../../services/dialogs-service';
import { PermisosService, PERM_ACCIONES_ID } from '../../../services/permisos-service';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import {
    PATH_BUSCADOR,
    PATH_BUSCADOR_CUENTAS,
    PATH_CONTACTO_DETAIL,
    PATH_CUENTA_DETAIL,
    PATH_CUENTAS,
    PATH_COLABORADOR_DETAIL
} from '../../../navigation/navigation.module';
import { TableDataSource } from '../../../utils';
import { UsuariosComponent } from '../usuarios';
import {FirebaseMessagingService} from '@services/firebase-messaging.service';

@Component({
  selector: 'app-cuentas',
  templateUrl: './cuentas.component.html',
  styleUrls: ['./cuentas.component.scss']
})
export class CuentasComponent implements OnInit, AfterViewInit, OnDestroy {

  ASSETS_URL = environment.ASSETS_URL;

  cuentaTypeProveedor = CUENTA_TYPE_PROVEEDOR;

  tabs = {
    EMPRESAS: 0,
    CONTACTOS: 1,
    PROSPECTOS: 2,
    USUARIOS: 3
  }

  contactosSubject$ = new BehaviorSubject<any[]>([]);
  contactosDataSource = new TableDataSource(this.contactosSubject$);
  contactosDisplayedColumns = ['fullName', 'empresa', 'actions'];
  contactosPage = 0;
  contactosResponseData = [];

  empresasSubject$ = new BehaviorSubject<any[]>([]);
  empresasDataSource = new TableDataSource(this.empresasSubject$);
  empresasDisplayedColumns = ['fullName', 'cuit', 'actions'];
  empresasPage = 0;
  empresasResponseData = [];

  prospectosSubject$ = new BehaviorSubject<any[]>([]);
  prospectosDataSource = new TableDataSource(this.prospectosSubject$);
  prospectosDisplayedColumns = ['fullName', 'cuit', 'fechaCreacion', 'actions'];
  prospectosPage = 0;
  prospectosResponseData = [];

  PERM_ACCIONES_ID = PERM_ACCIONES_ID;
  selectedTabIndex = this.tabs.EMPRESAS;
  appUsuariosLoaded = false;

  // for caching purposes
  private contactosCalled: boolean = false;
  private empresasCalled: boolean = false;
  private prospectosCalled: boolean = false;
  private agroCalled: boolean = false;

  private scrollSubscriber;

  // for sync purposes
  showContactosLoading: boolean = false;
  showEmpresasLoading: boolean = false;
  showProspectosLoading: boolean = false;

  usuariosAgroAllowed = false;
  @ViewChild(UsuariosComponent) usuariosComponent: UsuariosComponent;

  constructor(private navigationService: NavigationService,
              private cuentasService: CuentasService,
              private router: Router,
              private dialogsService: DialogsService,
              private route: ActivatedRoute,
              private location: Location,
              private permisosService: PermisosService,
              private firebaseService: FirebaseMessagingService,
  ) {
    this.usuariosAgroAllowed = this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.P_Usuario_Agro);
  }

  ngOnInit() {}

  loadData(){
    switch (this.selectedTabIndex) {
      case this.tabs.CONTACTOS:
        if(!this.contactosCalled) {
          this.getContactos();
        }
        break;
      case this.tabs.EMPRESAS:
        if (!this.empresasCalled) {
          this.getEmpresas();
        }
        break;
      case this.tabs.PROSPECTOS:
        if (!this.prospectosCalled) {
          this.getProspectos();
        }
        break;
      default:
        this.getContactos();
    }
  }

  navigateToBuscador(){
    this.router.navigate([PATH_BUSCADOR, PATH_BUSCADOR_CUENTAS]);
  }

  getContactos(page?: number){
        if (!this.showContactosLoading) {
          this.showContactosLoading = true;
          this.contactosCalled = true;
          this.cuentasService.getContactos(page)
            .subscribe( data => {
              this.contactosResponseData = [ ...this.contactosResponseData, ...data ];
              this.contactosSubject$.next(this.contactosResponseData);
              this.showContactosLoading = false;
            },
            err => this.showContactosLoading = false);
    }
  }

  getEmpresas(page?: number){
    if (!this.showEmpresasLoading) {
      this.showEmpresasLoading = true;
      this.empresasCalled = true;
      this.cuentasService.getEmpresas(page)
        .subscribe( data => {
          this.empresasResponseData = [ ...this.empresasResponseData, ...data ];

          this.empresasResponseData.forEach(emp => {
            if (emp.CuentaAcopio) {
              emp.cuentasAcopios = '';
              emp.CuentaAcopio.forEach(e => {
                if (e.CuentaAcopio !== 0) {
                  emp.cuentasAcopios += e.CuentaAcopio.toString() + ', ';
                }
              });
              if (emp.cuentasAcopios.length) {
                emp.cuentasAcopios = emp.cuentasAcopios.slice(0, -2);
              }
            }
          });

          this.empresasSubject$.next(this.empresasResponseData);
          this.showEmpresasLoading = false;
        },
        err => this.showEmpresasLoading = false);
    }
  }

  getProspectos(page?: number){
    if (!this.showProspectosLoading) {
      this.showProspectosLoading = true;
      this.prospectosCalled = true;
      this.cuentasService.getProspectos(page)
        .subscribe( data => {
          data.forEach(p => {
            // Hacky solution but there is no time for anything else. With this we're sure that the todate pipe
            // will parse this date, but if it was 0 it wouldn't
            p.FechaCreacion += (p.FechaCreacion === 0 ? 1 : 0);
          });
          this.prospectosResponseData = [ ...this.prospectosResponseData, ...data ];
          this.prospectosSubject$.next(this.prospectosResponseData);
          this.showProspectosLoading = false;
        },
        err => this.showProspectosLoading = false);
    }
  }

  selectTab(e: number) {
    const pages = ['/contactos', '/empresas', '/prospectos', '/usuarios'];
    this.location.go(PATH_CUENTAS + pages[e]);

    if (e === this.tabs.CONTACTOS && !this.contactosCalled) {
      this.getContactos();
    } else if (e === this.tabs.EMPRESAS && !this.empresasCalled) {
      this.getEmpresas();
    } else if (e === this.tabs.PROSPECTOS && !this.prospectosCalled) {
      this.getProspectos();
    } else if (e === this.tabs.USUARIOS) {
      this.appUsuariosLoaded = true;
    }

    this.selectedTabIndex = e;

    // Analytics
    this.firebaseService.sendToAnalytics(PATH_CUENTAS + pages[e]);
  }

  onContactoSelected(contacto){
    this.router.navigate([PATH_CONTACTO_DETAIL, contacto.ClientContactId]);
  }

  onCuentaSelected(cuenta){
    this.router.navigate([PATH_CUENTA_DETAIL, cuenta.Id])
  }

  onDeleteCuenta(cuenta){
    this.dialogsService.confirm(null,
                '¿Está seguro de que desea eliminar esta cuenta?',
                'SÍ, ELIMINAR',
                'NO, CANCELAR')
      .subscribe( res => {
        if (res){
          this.cuentasService.deleteCuenta(cuenta.Id)
            .subscribe( data => {
              if (data.ResponseData){
                this.empresasResponseData.splice(this.empresasResponseData.findIndex(val => val.Id === cuenta.Id),1);
                this.empresasSubject$.next(this.empresasResponseData);
                this.prospectosResponseData.splice(this.prospectosResponseData.findIndex(val => val.Id === cuenta.Id), 1);
                this.prospectosSubject$.next(this.prospectosResponseData);
              }
            });
        }});
  }

  onDeleteContacto(contacto){
    this.dialogsService.confirm(null,
                '¿Está seguro de que desea eliminar este contacto?',
                'SÍ, ELIMINAR',
                'NO, CANCELAR')
      .subscribe( res => {
        if (res){
          this.cuentasService.deleteContacto(contacto.ClientContactId)
            .subscribe( data => {
              this.getContactos();
            });
        }});
  }

  onActivateCuenta(cuenta, activate: boolean){
    this.dialogsService.confirm(null,
                activate ? '¿Está seguro de que desea activar esta cuenta?' : '¿Está seguro de que desea desactivar esta cuenta?',
                activate ? 'SÍ, ACTIVAR' : 'SÍ, DESACTIVAR',
                'NO, CANCELAR')
      .subscribe( res => {
        if (res){
          this.cuentasService.activateCuenta(cuenta.Id)
            .subscribe( data => {
              if (data.ResponseData){

                for (let empresa of this.empresasResponseData){
                  if (empresa.Id === cuenta.Id){
                    empresa.Habilitada = activate;
                    this.empresasSubject$.next(this.empresasResponseData);
                    return;
                  }
                }

                for (let prospecto of this.prospectosResponseData){
                  if (prospecto.Id === cuenta.Id){
                    prospecto.Habilitada = activate;
                    this.prospectosSubject$.next(this.prospectosResponseData);
                    return;
                  }
                }
              }
            });
        }});
  }

  /** cuenta = (empresa o prospecto) */
  showNewConsignaDialog(cuenta){
    this.dialogsService.showNewConsignaDialog('Nueva Consigna', 'ACEPTAR', 'CANCELAR', 'MÁS OPCIONES', null, cuenta, null);
  }

  showNewNegocioDialog(cuenta) {
    this.dialogsService.showNewNegocioDialog(null, false, {Id: cuenta.Id, FullName: cuenta.FullName});
  }

  showEditContactoDialog(contacto){
    this.dialogsService.showNewContactoDialog(
      null,
      contacto,
      'GUARDAR',
      'CANCELAR'
    ).subscribe( () => {
        this.getContactos();
    });
  }

  showEditCuentaDialog(cuenta){
    this.dialogsService.showNewCuentaDialog(cuenta, 'ACEPTAR', 'CANCELAR')
      .subscribe( (value) => {
        if (value) {
          this.resetCuentasLists();
        }
      });
  }

  showNewConsignaDialogFromContacto(contacto){
    this.dialogsService.showNewConsignaDialog('Nueva Consigna', 'ACEPTAR', 'CANCELAR', 'MÁS OPCIONES', null, null, contacto);
  }

  onCreateNewCuenta(index){
    this.dialogsService.showNewCuentaDialog(null, 'ACEPTAR', 'CANCELAR')
      .subscribe( (value) => {
        if (value) {
          this.resetCuentasLists();
        }
      });
  }

  onCreateNewContacto(){
    this.dialogsService.showNewContactoDialog(null, null, 'ACEPTAR', 'CANCELAR')
      .subscribe( value => {
        this.getContactos();
      })
  }

  resetCuentasLists() {
    this.contactosPage = 0;
    this.contactosResponseData = [];
    this.empresasPage = 0;
    this.empresasResponseData = [];
    this.prospectosPage = 0;
    this.prospectosResponseData = [];
    this.getContactos(0);
    this.getEmpresas(0);
    this.getProspectos(0);
    this.empresasCalled = true;
    this.prospectosCalled = true;
    this.contactosCalled = true;
  }

  toggleNav() {
    this.navigationService.toggleNav(true);
  }

  public ngAfterViewInit(): void {
    this.route.params.subscribe(params => {
      let page = this.route.snapshot.params['page'];

      switch(page){
        case 'contactos':
          this.selectTab(0);
          break;
        case 'empresas':
          this.selectTab(1);
          break;
        case 'prospectos':
          this.selectTab(2);
          break;
        case 'usuarios':
          if (this.usuariosAgroAllowed) {
            this.selectTab(3);
          } else {
            this.selectTab(0);
          }
          break;
      }
      this.loadData();
    });

    const content = document.querySelector('.mat-drawer-content');
    this.scrollSubscriber = Observable.fromEvent(content, 'scroll')
      .debounceTime(300)
      .map(() => content.scrollTop)
      .subscribe(x => {
        let max = content.scrollHeight - content.clientHeight;

        if ( x > max * 0.7){
          switch(this.selectedTabIndex){
            case this.tabs.CONTACTOS:
              if (!this.showContactosLoading) {
                this.contactosPage ++;
                this.getContactos(this.contactosPage);
              }
              break;
            case this.tabs.EMPRESAS:
              if (!this.showEmpresasLoading) {
                this.empresasPage ++;
                this.getEmpresas(this.empresasPage);
              }
              break;
            case this.tabs.PROSPECTOS:
              if (!this.showProspectosLoading) {
                this.prospectosPage ++;
                this.getProspectos(this.prospectosPage);
              }
              break;
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.scrollSubscriber) {
      this.scrollSubscriber.unsubscribe();
    }
  }

  permisoAutorizado(id) {
    return this.permisosService.permisoAutorizado(id);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/cuentas/cuentas.component.ts